import CCPAStatic from "@/layouts/CCPAStatic/CCPAStatic.vue";
import CCPAForm from "@/components/CCPAForm/CCPAForm.vue";
import { isSmallDevice } from "@/common/functions";

export default {
    components: {
        CCPAStatic,
        CCPAForm,
    },
    data() {
        return {
            layout: CCPAStatic,
            pageH1: this.$t("ccpaPageH1"),
            agreement: {
                req_to_know: false,
                req_to_opt_out: false,
                req_to_delete: false
            }
        }
    },
    methods: {
        isSmallDevice
    }
};



// WEBPACK FOOTER //
// ./src/pages/Ccpa/CcpaPage.js